import React from 'react';
import PropTypes from 'prop-types';
import WStoreTradeItem from '../WStoreTradeItem';
import './WStoreTrades.css';

function WStoreTrades({ tradeItems }) {
  return (
    <div className="wstore-trades">
      {tradeItems.map(tradeItem => (
        <WStoreTradeItem
          wscoreAmount={tradeItem.wscoreAmount}
          gemType={tradeItem.gemType}
          gemAmount={tradeItem.gemAmount}
        />
      ))}
    </div>
  );
}

WStoreTrades.propTypes = {
  tradeItems: PropTypes.arrayOf(
    PropTypes.shape({
      wscoreAmount: PropTypes.number.isRequired,
      gemType: PropTypes.string.isRequired,
      gemAmount: PropTypes.number.isRequired
    })
  )
};

export default WStoreTrades;
